import styled from 'styled-components';

import bg_desktop from '@assets/images/tournaments/tournaments.png';

export const Wrapper = styled.div`
	background-image: url('${bg_desktop}');
	background-size: cover;
	background-repeat: no-repeat;
	padding-bottom: 80px;
	position: relative;
`;

export const Container = styled.div`
	transition: all 0.2s linear;
	margin-bottom: 70px;
	position: relative;
	z-index: 2;
	max-width: 1760px;
	margin: 0 auto;
	padding: 0 20px;
`;

export const Header = styled.div`
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light30};
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	padding-bottom: 31px;
	margin-bottom: 24px;

	@media (max-width: 1100px) {
		display: none;
	}
`;

export const MobHeader = styled.div`
	display: none;

	@media (max-width: 1100px) {
		display: block;
	}
`;

export const EmptyDiv = styled.div``;

export const Month = styled.div`
	align-items: center;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	display: flex;
	gap: 20px;
	justify-content: center;
	font-weight: 600;
	font-size: 18px;

	@media (max-width: 1100px) {
		font-size: 20px;
		margin-bottom: 24px;
	}
`;

export const ArrowWrapper = styled.div`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.transparent.light15};
	border-radius: 50%;
	cursor: pointer;
	display: flex;
	height: 32px;
	justify-content: center;
	width: 32px;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	@media (max-width: 1100px) {
		height: 32px;
		width: 32px;
	}
`;

export const MonthText = styled.div`
	align-items: center;
	display: flex;
	padding-top: 5px;
`;

export const Filter = styled.div`
	align-items: center;
	display: flex;
	gap: 12px;
	justify-content: flex-end;

	@media (max-width: 1100px) {
		margin-top: 24px;
		margin-bottom: 24px;
		justify-content: flex-end;
	}
`;

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
`;

export const DayOfWeek = styled.div`
	text-align: center;
	margin-bottom: 24px;
	margin-top: 24px;

	&::after {
		content: attr(data-day);
		background-color: ${({ theme }) => theme.colors.text.alwaysWhite};
		border-radius: 4px;
		color: ${({ theme }) => theme.colors.text.alwaysDark};
		display: inline-block;
		font-size: 14px;
		font-weight: 500;
		padding: 6px 12px;
	}
`;

export const DayEmpty = styled.div`
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	background-color: transparent;
	border: none;
	min-height: 217px;
	border-radius: 8px;
`;

export const Day = styled.div<{ $isToday?: boolean }>`
	min-height: 217px;
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	padding-top: 31px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	background-color: ${({ theme }) => theme.colors.other.calendarDefault};
	border-radius: 8px;
	padding-bottom: 31px;
	position: relative;

	${props =>
		props.$isToday &&
		`
		background-color: ${props.theme.colors.background.secondary};
		z-index: 0;
		padding-top: 36px;
	`}

	@media (max-width: 700px) {
		min-height: 157px;
	}
`;

export const DayNum = styled.span<{ $isToday?: boolean }>`
	left: 10px;
	position: absolute;
	top: 10px;
	font-size: 14px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	${props =>
		props.$isToday &&
		`
		color: ${props.theme.colors.text.alwaysDark};
		background-color: ${props.theme.colors.text.alwaysWhite};
		border-radius: 50%;
		width: 24px;
		height: 24px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
	`}
`;

export const Event = styled.div<{ $backgroundColor?: string; $color?: string }>`
	cursor: pointer;
	font-size: 13px;
	font-weight: 500;
	margin-bottom: 4px;
	padding: 4px 8px;
	background-color: ${props => props.$backgroundColor || props.theme.colors.control.primary};
	color: ${props => props.$color || props.theme.colors.text.alwaysDark};
	font-size: 12px;
	text-overflow: ellipsis;

	@media (max-width: 700px) {
		padding: 4px 2px;
		font-size: 6px;
	}
`;

export const GameIcons = styled.div`
	bottom: 8px;
	display: flex;
	gap: 10px;
	left: 8px;
	position: absolute;

	@media (max-width: 700px) {
		gap: unset;
		justify-content: space-between;
		left: 6px;
		right: 6px;
	}
`;

export const GameIcon = styled.div``;

// Modal styles
export const Modal = styled.div`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.background.modalView};
	bottom: 0;
	display: flex;
	justify-content: center;
	left: 0;
	right: 0;
	position: fixed;
	top: 0;
	z-index: 2;
`;

export const ModalWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 8px;
	width: 50%;

	@media (max-width: 700px) {
		height: 100%;
		width: 100%;
	}
`;

export const ModalImg = styled.div<{ $backgroundImage?: string }>`
	background-image: url(${props => props.$backgroundImage});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	height: 193px;
	width: 100%;
`;

export const ModalInfo = styled.div`
	padding: 16px 20px;
`;

export const ModalTitle = styled.h2`
	color: ${({ theme }) => theme.colors.text.title};
	font-size: 24px;
	font-weight: 700;
	margin: 0;
`;

export const ModalGame = styled.div`
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light30};
	display: flex;
	gap: 16px;
	margin-top: 16px;
	padding-bottom: 16px;
`;

export const ModalGameItem = styled.div`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkPurple};
	border-radius: 100px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	display: flex;
	gap: 4px;
	font-size: 13px;
	font-weight: 400;
	padding: 6px 7px;

	&.cs2 {
		background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkGreen};
	}

	&.lol {
		background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkBlue};
	}
`;

export const ModalCalendar = styled.div`
	align-items: center;
	color: ${({ theme }) => theme.colors.text.title};
	display: flex;
	font-size: 16px;
	font-weight: 500;
	gap: 8px;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}
`;

export const ModalDescription = styled.div`
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 16px;
	font-weight: 400;
	line-height: 150%;
	margin-top: 16px;
`;

export const ModalButtons = styled.div`
	display: flex;
	gap: 16px;
	justify-content: flex-end;
	margin-top: 20px;
`;

export const ModalButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
	padding: 12px 24px;
	border-radius: 8px;
	border: none;
	cursor: pointer;
	font-weight: 500;
	transition: background-color 0.2s;

	${props =>
		props.$variant === 'primary'
			? `
		background-color: ${props.theme.colors.control.primary};
		color: ${props.theme.colors.text.alwaysDark};
		
		&:hover {
			background-color: ${props.theme.colors.control.hover};
		}
	`
			: `
		background-color: ${props.theme.colors.transparent.light10};
		color: ${props.theme.colors.text.alwaysWhite};
		
		&:hover {
			background-color: ${props.theme.colors.transparent.light15};
		}
	`}
`;
